export default __webpack_public_path__ + "static/Flexibility-6bba90238f62b8d6b42bac99b139b02f.webp";